module.exports = "https://cdn.realtymogul.com/static/media/Dustin_C.448f39d7.jpg";